export const NO_INTERNET = 'ログインに失敗しました'
export const UNAUTHENTICATED = 'ログアウトしました。再度ログインしてください。'
export const SERVER_ERROR = 'サーバーエラーが発生しました。'

export const ERROR_MESSAGE_BAD_REQUEST = '依頼を登録できませんでした。'
export const ERROR_USER_REGISTRATION_BAD_REQUEST = '登録に失敗しました。'
